import { Injectable } from '@angular/core';
import { KYMW7005Model } from '../kymw7005.model';
import { Feature } from '../vo/feature.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetFeatureListResponse = {
  FeatureCode: string,
  FeatureName: string,
}[];

@Injectable({
  providedIn: 'root'
})
export class GetFeatureListService extends PlessJsonResponderSub<GetFeatureListResponse>  {

  model: KYMW7005Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureRequestListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetFeatureList: {
          condition: {
            OrderCode: this.model.queryParams.orderCode,
            MediumType: this.model.queryParams.mediumType
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureRequestListService
   */
  execute(model: KYMW7005Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getFeatureList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureRequestListService
   */
  success(data: GetFeatureListResponse) {
    this.model.featureList = data.map(_ => 
      new Feature(
        _.FeatureCode,
        _.FeatureName,
      )
    );
    if (this.calbak) this.calbak();
  }
  
}